export default __webpack_public_path__ + "static/media/16.35b1683b.svg";